module.exports = __webpack_public_path__ + "static/media/surveyChattyNew.d64939f7.png";